import { Pipe, PipeTransform, LOCALE_ID, Injector } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'fuel' })
export class FuelPipe implements PipeTransform {

    constructor(private injector: Injector) { }

    public transform(value: number): string {
        const localeId = this.injector.get(LOCALE_ID);
        const formater = new DecimalPipe(localeId);
        const result = formater.transform(value, '1.0-1');
        return result!;
    }
}
